import { jsx as _jsx } from "react/jsx-runtime";
export var defaultRenderButton = function defaultRenderButton(_ref) {
  var onClick = _ref.onClick,
      className = _ref.className,
      label = _ref.label;
  return /*#__PURE__*/_jsx("button", {
    type: "button",
    className: className,
    onClick: onClick,
    children: label
  });
};